<div class="terminal-dialog-container">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <h3 class="dialog-title">Terminal List</h3>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Shop Info -->
  <div class="shop-info">
    <span class="shop-label">Shop: {{data.shopName}}({{data.shopCode}})</span>
    <!-- <span class="shop-name" *ngIf="data.shopName">- {{data.shopName}}</span> -->
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading terminals...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="error-container">
    <mat-icon>error</mat-icon>
    <p>{{error}}</p>
    <button mat-button color="primary" (click)="loadTerminals()">
      <mat-icon>refresh</mat-icon>
      Retry
    </button>
  </div>

  <!-- Terminals List -->
  <div *ngIf="!isLoading && !error" class="terminals-container">
    <div *ngIf="terminals.length === 0" class="no-terminals">
      <mat-icon>info</mat-icon>
      <p>No terminals found for this shop.</p>
    </div>

    <div *ngIf="terminals.length > 0" class="terminals-list">
      <!-- Select All Option -->
      <!-- <div class="select-all-container">
        <mat-checkbox (change)="toggleSelectAll()">
          Select All ({{getSelectedCount()}} selected)
        </mat-checkbox>
      </div> -->
      
      <div *ngFor="let terminal of terminals" class="terminal-item" [ngClass]="{'terminal-selected': terminal.selected}">
        <div class="terminal-info">
          <mat-checkbox class="terminal-checkbox" [(ngModel)]="terminal.selected">
          </mat-checkbox>
          <span class="terminal-name">{{terminal.code || terminal.terminal_id}}</span>
        </div>
        <!-- Success terminal indicator -->
        <div class="terminal-status" *ngIf="terminal.isSuccessTerminal">
          <mat-icon class="assigned-icon">check_circle</mat-icon>
        </div>
      </div>
    </div>
  </div>

  <!-- Dialog Actions -->
  <div class="dialog-actions">
    <!-- Display save errors -->
    <div *ngIf="error && !isLoading" class="save-error">
      <mat-icon color="warn">error</mat-icon>
      <span>{{error}}</span>
    </div>
    
    <div class="action-buttons">
      <button mat-raised-button color="primary" 
              (click)="onSave()" 
              *ngIf="terminals.length > 0"
              [disabled]="isSaving">
        <mat-spinner *ngIf="isSaving" diameter="20" style="margin-right: 8px;"></mat-spinner>
        <span *ngIf="!isSaving">Save</span>
        <span *ngIf="isSaving">Saving...</span>
      </button>
      <button mat-button (click)="onClose()" [disabled]="isSaving">Close</button>
    </div>
  </div>
</div>
